import * as arrearsActions from '../actions/arrears.actions';
import { ArrearsCollection } from '../models/arrears-collection';
import { createEntityAdapter, EntityState } from '@ngrx/entity';
import { AdminArrearsDataModel } from '../models/admin-arrears-data.model';
import { ArrearsLabels } from '../models/arrears-labels.model';

export class ArrearsInstance {
  id: string;
  groupByField1: string;
  groupByField2: string;
  column1Header: string;
  selectedCurrency: string;
  
}

export const arrearsWidgetAdapter = createEntityAdapter<ArrearsInstance>();

export interface ArrearsState extends EntityState<ArrearsInstance> {
  arrears: ArrearsCollection;
  adminData: AdminArrearsDataModel;
  adminDataError: string;
  adminDataLoading: boolean;
  agedDayLabels: ArrearsLabels;
  loading: boolean;
  error: string;
}

export const INITIAL_STATE: ArrearsState = arrearsWidgetAdapter.getInitialState({
  arrears: undefined,
  adminData: undefined,
  adminDataError: '',
  adminDataLoading: false,
  agedDayLabels: undefined,
  loading: false, // add a top level loading flag
  error: '', // add a top level error string
});

export function reducer(state: ArrearsState = INITIAL_STATE, action: arrearsActions.Actions) {
  switch (action.type) {
    case arrearsActions.LOAD:
    {
      state.arrears = undefined;
      state.loading = true;
        if ((<Array<string>>state.ids).indexOf(action.widgetId) !== -1) {
          return arrearsWidgetAdapter.updateOne({ id: action.widgetId.toString(), changes: { } }, state);
        }

        return arrearsWidgetAdapter.addOne({
          id: action.widgetId.toString(),
          groupByField1: null,
          groupByField2: null,
          column1Header: null,
          selectedCurrency: null
        }, state);

      }
    case arrearsActions.LOAD_COMPLETE:
      {
        state.arrears = action.payload;
        state.loading= false;
        if ((<Array<string>>state.ids).indexOf(action.widgetId) !== -1) {
          return arrearsWidgetAdapter.updateOne({
            id: action.widgetId.toString(),
            changes: {
              id: action.widgetId.toString(),
            }
          }, state);
        }
        return arrearsWidgetAdapter.addOne({
          id: action.widgetId.toString(),
          groupByField1: null,
          groupByField2: null,
          column1Header: null,
          selectedCurrency: null
        }, state);

      }
      case arrearsActions.LOAD_ERROR:
        {
          let errorMessage = null;
          if (action.payload.hasOwnProperty('message')) {
            errorMessage = action.payload.message;
          }
          return {
            ...state,
            loading: true,
            error: errorMessage
          };
        }
  
    case arrearsActions.UPDATE_GROUPING:
      {
        if ((<Array<string>>state.ids).indexOf(action.widgetId) !== -1) {
          return arrearsWidgetAdapter.updateOne({ id: action.widgetId.toString(), changes: { id: action.widgetId.toString(), groupByField1: action.groupByField1, groupByField2: action.groupByField2, column1Header: action.column1Header, selectedCurrency: action.currency } }, state);
        }
        return arrearsWidgetAdapter.addOne({
          id: action.widgetId.toString(),
          groupByField1: action.groupByField1,
          groupByField2: action.groupByField2,
          column1Header: action.column1Header,
          selectedCurrency: action.currency
        }, state);
      }
    case arrearsActions.LOAD_ADMIN_DATA_COMPLETE:
      {
        return { ...state, adminDataLoading: false, adminDataError: null, adminData: action.payload };
      }

    case arrearsActions.LOAD_ADMIN_DATA_ERROR:
      {
        let errorMessage = null;
        if (action.payload.hasOwnProperty('message')) {
          errorMessage = action.payload.message;
        }
        return { ...state, adminDataLoading: false, adminDataError: errorMessage, adminData: undefined };
      }

    case arrearsActions.LOAD_LABELS_COMPLETE:
      {
        return { ...state, agedDayLabels: action.payload };
      }

    default:
      {
        return state;
      }
  }
}
